import React from 'react';
import { Page, Document, StyleSheet } from '@react-pdf/renderer';
import PdfHeader from './components/reusable/PdfHeader';
import ServiceTechnicianSection from './components/reusable/ServiceTechnicianSection';
import BaySection from './inspection/BaySection';
import SystemInfoSection from './inspection/SystemInfoSection';
import FinalCheckSection from './inspection/FinalCheckSection';
import PageNumber from './components/reusable/PageNumber';
import generatePdfLayout from '../generatePdfLayout';

const styles = StyleSheet.create({
    body: {
        padding: 15,
        paddingBottom: 25, // For page number
    },
});

interface StorageInspectionPdfProps {
    data: {
        inspectionSheet: any;
        dept?: string;
        baseSheet?: any;
    };
    user: any;
}

interface PdfComponent {
    type: string;
    data: any;
}

const StorageInspectionPdf: React.FC<StorageInspectionPdfProps> = ({ data, user }) => {
    const layout: PdfComponent[][] = generatePdfLayout(data);

    const renderComponent = (component: PdfComponent) => {
        switch (component.type) {
            case 'pdfHeader':
                return <PdfHeader company={data.baseSheet?.company || ''} sheet={component.data} />;
            case 'SystemInfoSection':
                return <SystemInfoSection inspectionSheet={component.data} />;
            case 'BaySection':
                return <BaySection bay={component.data} inspectionSheet={data.inspectionSheet} />;
            case 'FinalCheckSection':
                return <FinalCheckSection inspectionSheet={data.inspectionSheet} />;
            case 'TechnicianSection':
                return <ServiceTechnicianSection techs={component.data} />;
            default:
                return null;
        }
    };

    return (
        <Document>
            {layout.map((page, pageIndex) => (
                <Page key={pageIndex} size="A4" style={styles.body}>
                    {page.map((component, componentIndex) => (
                        <React.Fragment key={componentIndex}>
                            {renderComponent(component)}
                        </React.Fragment>
                    ))}
                    <PageNumber
                        sheetType={data.dept === 'chemApps' ? "Custom App Inspection" : "Storage Inspection"} />
                </Page>
            ))}
        </Document>
    );
};

export default StorageInspectionPdf;
